import type MailListItemAnimationStore from './schema/MailListItemAnimationStore';
import { createStore } from 'owa-satcheljs';

const MailListItemAnimationDefaultStore: MailListItemAnimationStore = {
    activeAnimations: [],
    pendingAnimations: [],
    completedAnimations: [],
};

export const mailListItemAnimationStore: () => MailListItemAnimationStore =
    createStore<MailListItemAnimationStore>('MailItem', MailListItemAnimationDefaultStore);
